import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { isLightColor } from '../../../utils';

enum iconSize {
  extraSmall,
  small,
  regular
}

@Component({
  selector: 'app-membership-icon',
  templateUrl: './membership-icon.component.html',
  styleUrls: ['./membership-icon.component.css']
})
export class MembershipIconComponent implements OnInit, OnChanges {

  @Input() colorHex: string;
  @Input() iconInitials: string;
  @Input() size: iconSize = iconSize.regular;

  strokeWidth: number;
  textColor: string;

  iconSize = iconSize;

  constructor() { }

  ngOnInit() {
    this.setIconConfigPerColor(this.colorHex);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setIconConfigPerColor(changes.colorHex.currentValue);
  }

  private setIconConfigPerColor(colorHex: string) {
    if (isLightColor(colorHex)) {
      this.strokeWidth = 1;
      this.textColor = 'black';
    } else {
      this.strokeWidth = 0;
      this.textColor = 'white';
    }
  }

}
